/*
 * @Description: 与SDK通信接口
 * @Date: 2019-09-19 10:35:31
 * @Author: yaoshun
 * @LastEditTime: 2019-09-19 17:45:24
 */
import jsBridge from '../common/jsBridge'

function getInvokeDatas(type, params = {}) {
    console.warn('===== >>>>> 发起一次开发者回调 >>>>>', {type, params})
    const {unitId, data} = params
    console.warn('=====', {type, unitId, data})
    return {
        fnName: 'VideoBridge/reactDeveloper',
        params: {
            type, unitId, data
        }
    }
}

/**
 * showsuccess
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperShowSucccess(params = {}) {
    const type = 1;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * showfailed (error)
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperShowFailed(params = {}) {
    const type = 2;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * playcompleted
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperPlayCompleted(params = {}) {
    const type = 3;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * endcardshowsuccess
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperEndCardShowSuccess(params = {}) {
    const type = 4;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * clicked
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperClicked(params = {}) {
    const type = 5;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * dismissed（boolean convert）
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperDismissed(params = {}) {
    const type = 6;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

